// extracted by mini-css-extract-plugin
module.exports = {"Promotions":"Promotions_Promotions__2sPLX"};